<template>
  <!-- 基础信息 -->
  <div class="salesman-form-base" v-if="formData">
    <Button
      class="save-btn border"
      ghost
      v-if="$units.pointAction('org_1_1') && [1, 2, 3, 4, 6].includes(formData.orgType * 1) && disabled"
      type="primary"
      @click="disabled = false"
      >编辑</Button
    >
    <Button
      class="save-btn border"
      ghost
      v-else-if="$units.pointAction('org_1_2') && formData.orgType == 5 && disabled"
      type="primary"
      @click="disabled = false"
      >编辑</Button
    >

    <div v-if="($units.pointAction('org_1_1') || $units.pointAction('org_1_2')) && !disabled">
      <Button class="save-btn" type="primary" @click="save()">保存</Button>
      <Button
        class="save-btn left"
        ghost
        type="primary"
        @click="
          $refs.form.resetFields();
          $emit('success', formData.id);
        "
        >取消</Button
      >
    </div>
    <Form ref="form" :model="formData" :label-width="110" class="page-form" :key="formData.id">
      <FormItem prop="name" :label="formData.orgType == 5 ? '渠道简称' : '机构简称'" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入" :disabled="disabled" maxlength="16" />
      </FormItem>
      <FormItem prop="fullName" :label="formData.orgType == 5 ? '渠道全称' : '机构全称'" class="two">
        <Input v-model="formData.fullName" placeholder="请输入" :disabled="disabled" maxlength="30" />
      </FormItem>
      <FormItem prop="innerCode" label="内部组织编码" :rules="$units.formRule.required('请输入')">
        <Input
          v-model="formData.innerCode"
          placeholder="请输入"
          :disabled="disabled || [2, 3, 4, 6].includes(userInfo.orgType * 1) || userInfo.organId == formData.id"
        />
      </FormItem>
      <FormItem prop="orgType" label="机构类型" :rules="$units.formRule.required('请输入')">
        <!-- 1、总部 2、省分 3、市级 4、区级 5、渠道' -->
        <Input :value="orgTypeMap[formData.orgType]" placeholder="请输入" disabled />
      </FormItem>
      <FormItem prop="parentName" label="上级组织" v-if="formData.orgType != 1" key="parentName">
        <Input :value="formData.parentName" placeholder="请输入" disabled />
      </FormItem>
      <FormItem prop="contacts" label="联系人">
        <Input v-model="formData.contacts" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="mobile" label="联系电话" :rules="oldMobile ? {} : $units.formRule.tel('请输入正确的手机号', false)">
        <Input v-model="formData.mobile" placeholder="请输入" :disabled="disabled" @on-change="mobileChange" />
      </FormItem>
      <FormItem prop="leaderId" label="组织负责人" v-if="formData.orgType != 5" key="leaderId">
        <lzSelect v-model="formData.leaderId" placeholder="请输入姓名或工号搜索" ref="leaderSelect" :disabled="disabled" :remote-method="getUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem v-if="formData.parentId == '0' || userInfo.organId == formData.parentId" prop="userId" label="推荐人" key="userId">
        <lzSelect v-model="formData.userId" placeholder="请输入姓名或工号搜索" ref="leaderSelect" :disabled="disabled" :remote-method="getUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem prop="sortNum" label="排序" v-if="formData.orgType != 1" key="sortNum">
        <template slot="label">
          排序
          <Tooltip content="数字越大，顺序越靠前" placement="top">
            <Icon type="md-help-circle" style="color: #a8adb7" />
          </Tooltip>
        </template>
        <Input v-model="formData.sortNum" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem label="所在地区" prop="city" :rules="$units.formRule.required('请选择')">
        <Input :value="formData.province + formData.city" placeholder="" v-if="disabled" disabled />
        <template v-else>
          <Select v-model="formData.province" placeholder="省" @on-change="provinceChange" filterable style="width: calc(50% - 5px)">
            <Option v-for="(item, i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
          </Select>
          <Select v-model="formData.city" placeholder="市" filterable style="width: calc(50% - 5px); margin-left: 10px">
            <Option v-for="(item, i) in cityList" :value="item.name" :key="i">{{ item.name }}</Option>
          </Select>
        </template>
      </FormItem>
      <FormItem prop="address" label="地址" class="two" v-if="formData.orgType != 5" key="address">
        <Input
          v-model="formData.address"
          type="textarea"
          placeholder="最多不超过30个字"
          maxlength="30"
          :autosize="{ minRows: 1 }"
          show-word-limit
          :disabled="disabled"
        />
      </FormItem>
      <FormItem label="监管报备" prop="supervise" v-if="$units.superviseShowVal()">
        <RadioGroup v-model="formData.supervise">
          <Radio label="0" :disabled="disabled">否</Radio>
          <Radio label="1" :disabled="disabled">是</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="orgCode" label="机构编码">
        <template slot="label">
          机构编码
          <Tooltip content="请填写保监的机构编码" placement="top" transfer>
            <Icon type="md-help-circle" style="color: #a8adb7" />
          </Tooltip>
        </template>
        <Input v-model="formData.orgCode" placeholder="请输入" :disabled="disabled || orgCodeDisabled" />
      </FormItem>
      <FormItem prop="socialCode" label="社会信用代码" key="socialCode">
        <Input v-model="formData.socialCode" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="postcode" label="邮编" v-if="formData.orgType != 5" key="postcode">
        <Input v-model="formData.postcode" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="ico" label="公司logo" v-if="(formData.orgType == 1 || formData.orgType == 5) && (!disabled || formData.ico)" key="ico">
        <uploadNew class="upload-box" v-model="icoData" :muti="false" fileType="img" @change="uploadImg" :disabled="disabled"></uploadNew>
      </FormItem>
      <FormItem prop="status" label="状态">
        <Input :value="formData.status == 1 ? '在营' : '停业'" placeholder="" v-if="curTreeData.isTop || disabled" disabled />
        <RadioGroup v-model="formData.status" v-else>
          <Radio label="1">在营</Radio>
          <Radio label="2">停业</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="templateName" label="服务费模板" v-if="formData.orgType != 1" key="templateName">
        <Input :value="formData.templateName" placeholder="请输入" disabled />
      </FormItem>
      <FormItem prop="remark" label="备注" class="full">
        <Input
          v-model="formData.remark"
          type="textarea"
          placeholder="最多不超过50个字"
          maxlength="50"
          :autosize="{ minRows: 3 }"
          show-word-limit
          :disabled="disabled"
        />
      </FormItem>
      <FormItem prop="taxpayerName" label="纳税人名称" key="taxpayerName">
        <Input v-model="formData.taxpayerName" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="taxpayerNum" label="纳税人识别号" key="taxpayerNum">
        <Input v-model="formData.taxpayerNum" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="bank" label="开户行" key="bank">
        <Select v-model="formData.bank" filterable clearable :disabled="disabled">
          <Option v-for="(txt, value) in bankList" :value="value" :key="value">{{ txt }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="accountName" label="户名" key="accountName">
        <Input v-model="formData.accountName" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="cardNum" label="银行账号" key="cardNum">
        <Input v-model="formData.cardNum" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="bankBranch" label="支行名称" key="bankBranch">
        <Input v-model="formData.bankBranch" placeholder="请输入" :disabled="disabled" />
      </FormItem>
      <FormItem prop="invoiceType" label="发票类型" key="invoiceType">
        <Select v-model="formData.invoiceType" filterable clearable transfer :disabled="disabled" @on-change="changeInvoiceType">
          <Option value="1">专票</Option>
          <Option value="2">普票</Option>
          <Option value="3">其他</Option>
        </Select>
      </FormItem>
      <FormItem prop="invoiceTax" label="发票税点" key="invoiceTax">
        <Input v-model="formData.invoiceTax" disabled />
      </FormItem>
    </Form>
  </div>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import lzSelect from '@/components/commons/lzSelect';
export default {
  components: {
    uploadNew,
    lzSelect
  },
  props: {
    formData: null,
    curTreeData: null
  },
  data() {
    return {
      disabled: true,
      orgCodeDisabled: true, //是否可编辑机构编码
      icoData: [],
      oldMobile: '',
      orgTypeMap: {
        '1': '总部',
        '2': '省分机构',
        '3': '市级机构',
        '4': '区级机构',
        '5': '渠道',
        '6': '营业部'
      },
      regionsArr: [], //区域数据
      cityList: [], //市级数据
      userInfo: {},
      bankList: [], //开户行
      dic: JSON.parse(localStorage.dic)
    };
  },
  watch: {
    disabled: {
      handler() {
        this.$emit('isEdit', !this.disabled);
        // if(this.disabled){
        // this.$refs.form&&this.$refs.form.resetFields();
        // }
      },
      immediate: true
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    setData(data) {
      this.oldMobile = data.mobile;
      this.disabled = true;
      this.orgCodeDisabled = !!data.orgCode && this.userInfo.bjsSync == 1;
      if (data.ico) {
        this.icoData = [
          {
            path: data.ico
          }
        ];
      } else {
        this.icoData = [];
      }
      this.getRegion(data);
      this.getBankList();
    },
    // 获取银行列表
    getBankList() {
      this.bankList = this.dic['BANK_TYPE'];
    },
    // 回显税点
    changeInvoiceType(val) {
      if (val == 1) {
        this.formData.invoiceTax = 0.02;
      } else if (val == 2) {
        this.formData.invoiceTax = 0.03;
      } else if (val == 3) {
        this.formData.invoiceTax = 0;
      } else {
        this.formData.invoiceTax = '';
      }
    },
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (this.oldMobile == formData.mobile) {
          delete formData.mobile;
        }
        const userList = this.$refs.leaderSelect.list;
        userList.forEach(item => {
          if (item.id == formData.leaderId) {
            formData.leaderType = item.type;
          }
        });
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          type: 'POST',
          url: '/buz/organizationBase/edit',
          apiPermissionCode: 'org_1_1',
          data: formData
        })
          .then(res => {
            this.$notice.success('保存成功');
            this.visible = false;
            this.oldMobile = this.formData.mobile;
            this.$emit('success', res.data.id);
            if (this.userInfo.organId == formData.id) {
              //修改自己信息刷新网站存储
              window.parent.postMessage(
                {
                  updateUserinfo: true,
                  appMessage: true
                },
                '*'
              );
            }
          })
          .finally(res => {
            this.loading = false;
          });
      });
    },
    // 负责人列表
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {
        orgaList: [this.userInfo.organId],
        selectSub: 1,
        type: 3
      };
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else {
        params.userName = keyword;
      }
      return this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 获取省市区域数据
    async getRegion(data) {
      this.regionsArr = await this.$store.dispatch('getRegion');
      if (data.province) {
        const city = this.regionsArr.find(item => {
          return item.name == data.province;
        });
        this.cityList = city.children;
      }
    },
    // 选择省
    provinceChange(name) {
      this.$set(this.formData, 'city', '');
      const data = this.regionsArr.find(item => {
        return item.name == name;
      });
      this.cityList = data.children;
    },
    // 上传图片
    uploadImg(data) {
      console.log(data);
      if (data.length == 0) {
        this.$set(this.formData, 'ico', '');
        return;
      }
      data = data[0];
      if (data.h != data.w) {
        this.$notice.msg('请上传正方形图片');
        this.icoData = [];
      } else {
        this.$set(this.formData, 'ico', data.path);
      }
    },
    // 手机号修改
    mobileChange() {
      this.oldMobile = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);
  &.red {
    background: #e3461f;
  }
  &.orange {
    background: orange;
  }
}
/deep/ .ivu-select-item {
  font-size: 12px !important;
}
@media screen and (min-width: 1200px) {
  .salesman-form-base {
    overflow: hidden;
  }
  .page-form {
    margin-right: -30px;
  }
  .page-form .ivu-form-item {
    padding-right: 30px;
  }
}
</style>